var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _c("div", { staticClass: "header" }, [
      _vm.language === "zh"
        ? _c("div", { staticClass: "zh" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.jsonData.name)),
            ]),
            _c("div", { staticClass: "code" }, [
              _vm._v(
                "股票代码：" +
                  _vm._s(_vm.jsonData.companyCode) +
                  " | 所属行业：" +
                  _vm._s(_vm.jsonData.xfhy)
              ),
            ]),
          ])
        : _vm.language === "en"
        ? _c("div", { staticClass: "en" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.jsonData.nameEng)),
            ]),
            _c("div", { staticClass: "code" }, [
              _vm._v(
                "Stock Code：" +
                  _vm._s(_vm.jsonData.companyCode) +
                  " ｜ Industry：" +
                  _vm._s(_vm.jsonData.xfhyEng)
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "menu", on: { click: _vm.showMenu } }, [
        _c("img", { attrs: { src: _vm.menuImg } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }